import { LOAD_RULES } from '../constants'

export default (userRules, globalRules, canEditGlobal) => ({
    type: LOAD_RULES,
    userRules,
    globalRules,
    canEditGlobal
})
